module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//2.jpg?589d83635aa45c1b1655b7ef974cef4f";